<template>
  <div class="loading">
    <div class="spinner"></div>
    <p>Gerando boleto, aguarde...</p>
  </div>
</template>

<script>
import CartService from "@/scripts/services/cart.service";

export default {
  data() {
    return {
      cartService: new CartService(),
    };
  },
  async mounted() {
    const el = document.getElementById('initial-loading');
  if (el) el.remove();

    await this.redirectToBoleto();
  },
  methods: {
    async redirectToBoleto() {
      const encryptedCartId = this.$route.query.orderId;
      if (!encryptedCartId) return;

      const link = await this.cartService.getBoletoLink(encryptedCartId);
      window.location.href = link;
    },
  },
};
</script>

<style scoped>
.loading {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>